import React, { Component } from "react";
import SectionHeader from "./sectionheader";

const title = <h2 data-description="title">How it works?</h2>;
const alignment = "section-header mb-20";
const subtitle = (
  <h4 className="mt-25 fw-700">Find Your Partner In Just Few Steps</h4>
);
const content =
  "BAT Matrimony will help you find your perfect match with just a few steps. You focus on what is most important to you, we do all the work.";

let HowWorksContentList = [
  {
    imgIcon: "./assets/images/bat-img/notes.svg",
    imgAlt: "Notes Icon",
    title: "Register",
    content:
      "Register to our website, fill up your profile completely, and put a beautiful image on your profile.",
  },
  {
    imgIcon: "./assets/images/bat-img/search.svg",
    imgAlt: "Search Iocn",
    title: "Find Your Partner",
    content:
      "Search your interests that you like. You'll also be recommended users based on your preferences.",
  },
  // {
  //   imgIcon: "./assets/images/bat-img/Connection.svg",
  //   imgAlt: "Connection Icon",
  //   title: "Connect",
  //   content:
  //     "Add friends, approach them, and chat with them. Be sure to share your audio, photo, and video too.",
  // },
  // {
  //   imgUrl: "assets/images/about/04.png",
  //   imgAlt: "About Thumb",
  //   countNumber: "15,000",
  //   countTitle: "Women Online",
  // },
];

const HowWorksSection = () => {
  return (
    <>
      <section className="padding-tb how-works-section">
        <div className="container">
          <SectionHeader
            title={title}
            subtitle={subtitle}
            alignment={alignment}
          />
          {/* <div className="subtitle">{subtitle}</div> */}
          <div className="content text-center mb-15">{content}</div>
          <div className="section-wrapper">
            <div className="row justify-content-center g-5">
              {HowWorksContentList.map((val, i) => (
                <div className="col-xl-4 col-lg-4 col-sm-6 col-12" key={i}>
                  <div className="card-container">
                    <div className="card-wrapper text-center">
                      <div className="card-heading">
                        <img src={`${val.imgIcon}`} alt={`${val.imgAlt}`} />
                      </div>
                      <div className="card-title">{val.title}</div>
                      <div className="card-content">{val.content}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="lets-connect">
              <button className="button login-btn text-white">
                Let's Start
              </button>
            </div> */}
          </div>
        </div>
      </section>
      <div className="section-break"></div>
    </>
  );
};

export default HowWorksSection;
